import { Button, ButtonIcon, ButtonInline } from '@remote-com/norma/core/button';
import { focusVisible } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

// Icons

// Helpers

export const ButtonOutline = styled(Button).attrs((props) => ({
  ...props,
  variant: 'outline',
}))`
  --textColor: var(--colors-blank);
  && {
    color: var(--textColor);
    background-color: transparent;

    ${focusVisible(css`
      background-color: transparent;
    `)}
  }
`;

export { Button, ButtonIcon, ButtonInline };
